import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import React from "react";
import LazyLoading from "./pages/LazyLoad";
import ProtectedRoute from "./ProtectedRoute";
const LazyHome = React.lazy(()=> import("./pages/Home"))
const LazyPrivacyPolicy = React.lazy(()=> import("./pages/PrivacyPolicy"))
const LazyContactUs = React.lazy(()=> import("./pages/ContactUs"))
const LazyRefundsAndReturnsPolicy = React.lazy(()=> import("./pages/RefundsAndReturnPolicy"))
const LazyDeliveryPolicy = React.lazy(()=> import("./pages/DeliveryPolicy"))
const LazyPaymentPolicy = React.lazy(()=> import("./pages/PaymentPolicy"))
const LazyTermsAndConditions = React.lazy(()=> import("./pages/TermsAndConditions"))
const LazySiteInformation = React.lazy(()=> import("./pages/SiteInformation"))
const LazyAboutUs = React.lazy(()=> import("./pages/AboutUs"))
const LazySignUp = React.lazy(()=> import("./pages/SignUp"))
const LazyLogin = React.lazy(()=> import("./pages/Login"))
const LazyShoppingCart = React.lazy(()=> import("./pages/ShoppingCart"))
const LazyCollections = React.lazy(()=> import("./pages/Collections"))
const LazyProductPage = React.lazy(()=> import("./pages/ProductPage"))
const LazyCheckOut = React.lazy(()=> import("./pages/CheckOut"))
const LazyPageNotFound = React.lazy(()=> import("./pages/PageNotFound"))
const LazySearchResult = React.lazy(()=> import("./pages/SearchResult"))
const LazyResetPassword = React.lazy(()=> import("./pages/ResetPassword"))
const LazyAdminLogin = React.lazy(()=> import("./adminPages/AdminLogin"))
const LazyAdminDashboard = React.lazy(()=> import("./adminPages/AdminDashboard"))
const LazyAdminNotification = React.lazy(()=> import("./adminPages/AdminNotifications"))
const LazyAdminEditProductSingle = React.lazy(()=> import("./adminPages/EditProductSingle"))
const LazyAdminCreateProduct = React.lazy(()=> import("./adminPages/AdminCreateProduct"))
const LazyAdminGetSingleNotification = React.lazy(()=> import("./adminPages/AdminGetSingleNotification"))
const LazyAdminSubscribers = React.lazy(()=> import("./adminPages/AdminSubscribers"))
const LazyOrders = React.lazy(()=> import("./pages/Orders"))

let App = ()=>{

  return(
    <>
    <Router>
      <Routes>
        
        <Route path="/" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyHome />
          </React.Suspense>
        } />

        <Route path="/privacy-policy" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyPrivacyPolicy />
          </React.Suspense>
        } />

        <Route path="/contact-us" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyContactUs />
          </React.Suspense>
        } />

        <Route path="/returns-and-refunds-policy" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyRefundsAndReturnsPolicy />
          </React.Suspense>
        } />

        <Route path="/delivery-policy" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyDeliveryPolicy />
          </React.Suspense>
        } />

        <Route path="/payment-policy" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyPaymentPolicy />
          </React.Suspense>
        } />

        <Route path="/terms-and-conditions" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyTermsAndConditions />
          </React.Suspense>
        } />

        <Route path="/site-information" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazySiteInformation />
          </React.Suspense>
        } />

        <Route path="/about-us" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyAboutUs />
          </React.Suspense>
        } />

        <Route path="/shopping-cart" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyShoppingCart />
          </React.Suspense>
        } />

        <Route path="/collections/:collections" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyCollections />
          </React.Suspense>
        } />

        <Route path="/sign-up" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazySignUp />
          </React.Suspense>
        } />

        <Route path="/sign-in" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyLogin />
          </React.Suspense>
        } />

        <Route path="/reset-password/:token" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyResetPassword />
          </React.Suspense>
        } />

        <Route path="/products/:custom" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyProductPage />
          </React.Suspense>
        } />

        <Route path="/checkout" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyCheckOut />
          </React.Suspense>
        } />

      <Route element={<ProtectedRoute />}>
          <Route path="/my-orders" exact element={
            <React.Suspense fallback={<LazyLoading />}>
              <LazyOrders />
            </React.Suspense>
          } />
        </Route>

        <Route path="/search-result" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazySearchResult />
          </React.Suspense>
        } />


        {/* Admin pages  */}
        <Route path="/admin/login" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyAdminLogin />
          </React.Suspense>
        } />

        <Route element={<ProtectedRoute isAdmin />}>
          <Route path="/admin/dashboard" exact element={
            <React.Suspense fallback={<LazyLoading />}>
              <LazyAdminDashboard />
            </React.Suspense>
          } />
        </Route>
        
        <Route element={<ProtectedRoute isAdmin />}>
          <Route path="/admin/notifications" exact element={
            <React.Suspense fallback={<LazyLoading />}>
              <LazyAdminNotification />
            </React.Suspense>
          } />
        </Route>

        <Route element={<ProtectedRoute isAdmin />}>
          <Route path="/admin/create-product" exact element={
            <React.Suspense fallback={<LazyLoading />}>
              <LazyAdminCreateProduct />
            </React.Suspense>
          } />
        </Route>

        <Route element={<ProtectedRoute isAdmin />}>
          <Route path="/admin/editproductsingle/:id" exact element={
            <React.Suspense fallback={<LazyLoading />}>
              <LazyAdminEditProductSingle />
            </React.Suspense>
          } />
        </Route>

        <Route element={<ProtectedRoute isAdmin />}>
          <Route path="/admin/notification/:id" exact element={
            <React.Suspense fallback={<LazyLoading />}>
              <LazyAdminGetSingleNotification />
            </React.Suspense>
          } />
        </Route>

        <Route element={<ProtectedRoute isAdmin />}>
          <Route path="/admin/subscribers" exact element={
            <React.Suspense fallback={<LazyLoading />}>
              <LazyAdminSubscribers />
            </React.Suspense>
          } />
        </Route>

      
        

        <Route path="*" exact element={
          <React.Suspense fallback={<LazyLoading />}>
            <LazyPageNotFound />
          </React.Suspense>
        } />

        
      </Routes>
    </Router>
    </>
  )
}

export default App;